import { format, isToday, isYesterday } from "date-fns";

export default function todayOrYesterday(dateObj?: Date | number): string {
  if (!dateObj) {
    return "";
  }

  const timeFormatForOutput = "HH:mm:ss '(UTC'xxx')'";
  const dateFormat = "EEE MMM d, yyyy";
  const dateTimeFormat = `${dateFormat} 'at' ${timeFormatForOutput}`;

  if (isToday(dateObj)) {
    return `Today at ${format(dateObj, timeFormatForOutput)}`;
  }

  if (isYesterday(dateObj)) {
    return `Yesterday at ${format(dateObj, timeFormatForOutput)}`;
  }

  return format(dateObj, dateTimeFormat);
}
